import { connect } from 'react-redux';
import { pipe, path } from 'ramda';
import { createMatchSelector } from 'connected-react-router';

import DeviceStatusInfo from 'components/DeviceStatusInfo';
import {
  getReportItemDeviceStatus,
  getReportItemDeviceStatusPhone,
  getReportItemDeviceStatusNotes,
} from 'store/selectors/reports/singleItems';

const mapStateToProps = state => {
  const observationId = pipe(
    createMatchSelector('/report/:observationId'),
    path(['params', 'observationId']),
  )(state);

  return {
    deviceStatus: getReportItemDeviceStatus(observationId)(state),
    deviceStatusPhone: getReportItemDeviceStatusPhone(observationId)(state),
    notes: getReportItemDeviceStatusNotes(observationId)(state),
  };
};
export default connect(mapStateToProps)(DeviceStatusInfo);
